import React, { useEffect, useState } from "react";
import { DialogComponent } from "../common/DialogComponent";
import MonitoringTab from "./MonitoringTab";
import CaseDetails from "../Dialogs/CaseDetails";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as alertActions from "../../store/AlertsService/actions";
import * as ConfigurationActions from "../../store/configurationService/actions";
import { ApplicationState } from "../../store";
import i18nService from "../../util/Internationalization/i18n/i18n";
import { useTranslation } from "react-i18next";
import { getFormattedDate } from "../../util/dateFormatting";
import LogoContainer from "../common/LogoContainer";

const Cases = () => {
    const { t: tLang } = useTranslation();
    const location = useLocation();
    const [alert, setAlert] = useState({});
    const [refresh, setRefresh] = useState(false);
    const dispatch = useDispatch();
    const isBusinessUser = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userServiceDetails && state.loggedInUser.userServiceDetails.isBusinessUser
            ? state.loggedInUser.userServiceDetails.isBusinessUser
            : false
    );
    const requestAlertData = (reload: boolean) => dispatch(alertActions.actionCreators.getAlertData(isBusinessUser, reload));
    const alerts: any = useSelector((state: ApplicationState) => (state.alertState && state.alertState.alertData ? state.alertState.alertData : []));
    const loading = useSelector((state: ApplicationState) => (state.alertState ? state.alertState.isAlertLoading : false));
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const [yScroll, setYScroll] = useState(0);
    useEffect(() => {
        if (location.state) {
            caseDetails(location.state);
        }
    }, []);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    useEffect(() => {
        if (refresh) {
            requestAlertData(true);
            setRefresh(false);
        }
    }, [refresh === true]);

    const caseDetails = (alert: any) => {
        setAlert(alert);
        setYScroll(scrollY);
        setShowCaseDetails(true);
    };

    useEffect(() => {
        requestAlertData(false);
    }, []);

    const [showCaseDetails, setShowCaseDetails] = useState(false);
    const handleCloseDialog = (): any => {
        setShowCaseDetails(false);
        setTimeout(()=>{
            scrollTo(0, yScroll);
        })
    };

    return (
        <React.Fragment>
            <div className=" row">
                <div className="col-xs-12 row">
                    <h1 className="title-page" id="monitoring-cases-page">
                        {tLang("alerts.title")}
                    </h1>
                    <LogoContainer internalPage={true} />
                </div>
            </div>

            <MonitoringTab selectedTab="2" />
            <div className="row" style={{ minHeight: "570px" }}>
                <div className="col-xs-12 col-sm-12">
                    <div className={`box offset-padding ${loading && "loading"}`}>
                        <div className="box-header">
                            <div className="box-title-container">
                                <div className="box-title-icon" aria-hidden="true">
                                    <em className="las la-clipboard"></em>
                                </div>
                                <div className="box-title-text has-actions">
                                    <h2 className="box-title">{tLang("alerts.cases.title")}</h2>
                                </div>
                            </div>
                        </div>
                        {alerts &&
                        Array.isArray(alerts) &&
                        alerts.filter(
                            (alert: any) =>
                                alert.alertStatus === "OPENCASE" ||
                                alert.alertStatus === "OPENED" ||
                                alert.alertStatus === "RESOLVED" ||
                                alert.alertStatus === "RESOLVEDCASE"
                        ).length > 0 ? (
                            <div className="box-content">
                                <div role="region" id="open-cases" aria-labelledby="open-cases-title">
                                    <h3 className="content-sub-title" id="open-cases-title">
                                        {tLang("alerts.cases.openCasesListTitle")} (
                                        <span id="open-case-count">
                                            {alerts && alerts.filter((alert: any) => alert.alertStatus === "OPENCASE" || alert.alertStatus === "OPENED").length}
                                        </span>
                                        )
                                    </h3>

                                    <ul id="open-cases-list">
                                        {alerts &&
                                            alerts
                                                .filter((alert: any) => alert.alertStatus === "OPENCASE" || alert.alertStatus === "OPENED")
                                                .map((alert: any, index: number) => {
                                                    return (
                                                        <li key={alert.alertID} onClick={() => caseDetails(alert)}>
                                                            <div className="monitoring-case-container status-alert">
                                                                <a href="javascript:void(0)">
                                                                    <span className="row">
                                                                        <span className="col-xs col-no-gutter flex-grow-null">
                                                                            <span className="monitoring-case-icon">
                                                                                <em className="las la-clipboard"></em>
                                                                            </span>
                                                                        </span>

                                                                        <span className="col-xs col-no-gutter">
                                                                            <span className="monitoring-case-date">
                                                                                <span className="sr-only">Case Date:</span>
                                                                                {alert.createdDate &&
                                                                                    getFormattedDate(i18nService.get("Country"), alert.createdDate)}
                                                                            </span>
                                                                            <span className="monitoring-case-description col-xs-8">
                                                                                {(isBusinessUser ? "Business " : "") + alert.displayName}
                                                                            </span>
                                                                            <span className="monitoring-case-status open">
                                                                                <span className="sr-only">Case Status: </span>
                                                                                {tLang("alerts.cases.openStatusTagText")}
                                                                            </span>
                                                                        </span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                        </li>
                                                    );
                                                })}
                                    </ul>
                                </div>

                                <div role="region" id="resolved-cases" aria-labelledby="resolved-cases-title">
                                    <h3 className="content-sub-title" id="resolved-cases-title">
                                        {tLang("alerts.cases.resolvedCasesListTitle")} (
                                        <span id="resolved-case-count">
                                            {alerts &&
                                                alerts.filter((alert: any) => alert.alertStatus === "RESOLVEDCASE" || alert.alertStatus === "RESOLVED").length}
                                        </span>
                                        )
                                    </h3>

                                    <ul id="resolved-cases-list">
                                        {alerts &&
                                            alerts
                                                .filter((alert: any) => alert.alertStatus === "RESOLVEDCASE" || alert.alertStatus === "RESOLVED")
                                                .map((alert: any, index: number) => {
                                                    return (
                                                        <li key={alert.alertID} onClick={() => caseDetails(alert)}>
                                                            <div className="monitoring-case-container status-alert">
                                                                <a href="javascript:void(0)">
                                                                    <span className="row">
                                                                        <span className="col-xs col-no-gutter flex-grow-null">
                                                                            <span className="monitoring-case-icon">
                                                                                <em className="las la-clipboard"></em>
                                                                            </span>
                                                                        </span>

                                                                        <span className="col-xs col-no-gutter">
                                                                            <span className="monitoring-case-date">
                                                                                <span className="sr-only">Case Date:</span>
                                                                                {alert.createdDate &&
                                                                                    getFormattedDate(i18nService.get("Country"), alert.createdDate)}
                                                                            </span>
                                                                            <span className="monitoring-case-description col-xs-8">
                                                                                {(isBusinessUser ? "Business " : "") + alert.displayName}
                                                                            </span>
                                                                            <span className="monitoring-case-status resolved">
                                                                                <span className="sr-only">Case Status: </span>
                                                                                {tLang("alerts.cases.resolvedStatusTagText")}
                                                                            </span>
                                                                        </span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                        </li>
                                                    );
                                                })}
                                    </ul>
                                </div>
                            </div>
                        ) : (
                            <div className="row" style={{ minHeight: "170px" }}>
                                <div className="box" style={{ backgroundColor: "#F2F6F9" }}>
                                    <div className="box-header col-xs-12 col-sm-12">
                                        <div className="content-sub-title text-align-center">
                                            <div className="monitoring-alert-icon" style={{ fontSize: "40px" }}>
                                                <em className="las la-exclamation-circle "></em>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="box-content text-align-center">
                                        <p>{tLang("alerts.cases.noCaseMessage")}</p>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {showCaseDetails && (
                <DialogComponent hideCloseButton={true} dialogId="case-details-dialog" title="Case Details" closeDialog={handleCloseDialog}>
                    <CaseDetails refresh={setRefresh} alert={alert} />
                </DialogComponent>
            )}
        </React.Fragment>
    );
};

export default Cases;
